/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { FeatureName } from './capabilities';

export const premiumPluginIdentifiers: Record<Capitalize<string>, Array<FeatureName>> = {
	CMT: [ 'Comments' ],
	TC: [ 'Track Changes' ],
	PAG: [ 'Pagination' ],
	RH: [ 'Revision History' ],
	DO: [ 'Document Outline' ],
	FP: [ 'Format Painter' ],
	SC: [ 'Slash Commands' ],
	TOC: [ 'Table Of Contents' ],
	TPL: [ 'Templates' ],
	POE: [ 'Enhanced Paste from Office' ],
	AI: [ 'AI Assistant' ],
	CC: [ 'Case Change' ],
	MLL: [ 'Multi-level Lists' ],
	MF: [ 'Merge Fields' ],
	SEE: [ 'Enhanced Source Code Editing' ],
	EIS: [ 'Export with Inline Styles' ],
	ECH: [ 'Email Configuration Helper' ],

	// Features do not checked by the editor (Cloud).
	RE: [ 'Real-time Collaborative Editing (Co-Authoring)' ],
	RCMT: [ 'Real-time Collaborative Comments' ],
	RTC: [ 'Real-time Collaborative Track Changes' ],
	RRH: [ 'Real-time Collaborative Revision History' ],

	BOX: [ 'CKBox', 'Image optimizer by CKBox' ],
	UPLC: [ 'Uploadcare', 'Image optimizer by Uploadcare' ],
	E2P: [ 'Export to PDF' ],
	E2W: [ 'Export to Word' ],
	IW: [ 'Import from Word' ],

	// Feature groups.
	PP: [
		'Document Outline',
		'Format Painter',
		'Slash Commands',
		'Table Of Contents',
		'Templates',
		'Enhanced Paste from Office',
		'Case Change',
		'Merge Fields'
	],

	// Features not available in Builder.
	CSFI: [],
	// The Builder won't be used to prepare an editor used inside the Drupal CMS.
	// Hence, let's map its features to an empty array. See: https://github.com/ckeditor/ckeditor5-builder/issues/1142.
	DRUP: []
};
